import axios from '@/js/helper/axios-helper.js'
import { stringify } from 'qs'
import { compact, flatten, get, has, head, isEmpty, isUndefined, set, uniq, trim } from 'lodash-es'

import PRODUCT_CONSTANTS, {
  AVAILABILITY_STORE_TYPES,
} from '@/js/plugins/store/modules/products/constants'
import PRODUCT_MUTATION_TYPES from '@/js/plugins/store/modules/products/mutation-types'
// import APP_MUTATION_TYPES from '@/js/plugins/store/modules/app/mutation-types'
import SEARCH_MUTATION_TYPES from '@/js/plugins/store/modules/search/mutation-types'
// import SEARCH_GETTER_TYPES from '@/js/plugins/store/modules/search/getter-types'
import APP_GETTER_TYPES from '@/js/plugins/store/modules/app/getter-types'
// import APP_ACTIONS from '@/js/plugins/store/modules/app/action-types'
import AIMEOS from '@/js/helper/aimeos-constants.js'
import {
  STORE_MODULES,
  AIMEOS_GETTER_TYPES,
  REQUEST_STATE,
  TYPES,
  APP_ACTION_TYPES,
} from './std-imports'
import { DP_ROLE } from '@/js/helper/dp-usermanagement-constants'

import AIMEOS_META_CONSTANTS from '@/js/helper/aimeos-meta-constants.js'
import BIKE_ATTRIBUTES from '@/js/helper/bike-attributes.js'
import FILTER_CONSTANTS from '@/js/helper/filter-constants.js'
import { CONSTANTS as ADDRESS_CONSTANTS } from '@/js/helper/aimeos-customer-address-constants'
// import ACTION_TYPES from '@/js/store/modules/aimeos/actions-types.js'

import APP_CONSTANTS from '@/js/plugins/store/modules/app/constants.js'
import APP_GETTER from '@/js/plugins/store/modules/app/getter-types.js'

import { getCheckoutApiActions } from './checkout-api-actions'
import { getCompareApiActions } from './compare-api-actions'
import { getAvailabilityWatchActions } from './availability-watch-actions'
import { addGetParamToUrl } from '@/js/helper/links-helper.js'

import { generateProductData } from '@/js/helper/product-data-helper'
import { generateOrderData } from '@/js/helper/order-data-helper'
// import { generateAttributeData } from '@/js/helper/product-attributes-helper'

const ProductSearchCancelToken = axios.CancelToken

export const getActions = MUTATION_TYPES => ({
  ...getCheckoutApiActions(MUTATION_TYPES),
  ...getCompareApiActions(MUTATION_TYPES),
  ...getAvailabilityWatchActions(MUTATION_TYPES),
  [TYPES.SET_OPTIONS_URL]: async ({ state, commit, dispatch }, url) => {
    if (get(state, MUTATION_TYPES.OPTIONS.urlKey) === url) {
      return Promise.resolve(get(state, MUTATION_TYPES.OPTIONS.dataKey))
    }

    commit(MUTATION_TYPES.OPTIONS.urlKey, url)

    return dispatch(TYPES.OPTIONS_REQUEST)
  },
  [TYPES.SET_CUSTOMER_URL]: ({ state, commit }, url) => {
    if (get(state, MUTATION_TYPES.CUSTOMER.urlKey) === url) {
      return
    }
    commit(MUTATION_TYPES.CUSTOMER.urlKey, url)
  },
  [TYPES.SET_SERVICE_URL]: ({ state, commit }, url) => {
    if (get(state, MUTATION_TYPES.SERVICE.urlKey) === url) {
      return
    }
    commit(MUTATION_TYPES.SERVICE.urlKey, url)
  },
  [TYPES.SET_ORDER_URL]: ({ state, commit }, url) => {
    if (get(state, MUTATION_TYPES.ORDER.urlKey) === url) {
      return
    }
    commit(MUTATION_TYPES.ORDER.urlKey, url)
  },

  [TYPES.TRACK_PRODUCT_SEARCH]: ({ rootGetters, dispatch }, { searchParams, filters }) => {
    const search = searchParams?.SearchText?.toString()
    if (isEmpty(search)) {
      return
    }

    const searchTypeParams =
      rootGetters[`${STORE_MODULES.APP}/${APP_GETTER_TYPES.FILTER_SEARCH_TYPE_REVERSE}`]
    const ids = flatten(filters?.f_attrid) || []
    const code = compact(ids.map(id => get(searchTypeParams, [id, 'code'])))
    const searchType = code.includes(BIKE_ATTRIBUTES.TYPE.ARCHIVE_ITEM)
      ? FILTER_CONSTANTS.SCOPE.ARCHIVE
      : code.includes(BIKE_ATTRIBUTES.ARTICLE_TYPE.SPAREPART)
      ? FILTER_CONSTANTS.SCOPE.SERVICE
      : code.includes(BIKE_ATTRIBUTES.TYPE.PRODUCT_VARIANTS_OUTLET)
      ? FILTER_CONSTANTS.SCOPE.OUTLET
      : code.includes(BIKE_ATTRIBUTES.ARTICLE_TYPE.BIKE)
      ? FILTER_CONSTANTS.SCOPE.CURRENT
      : ''

    if (!searchType) {
      return
    }

    dispatch(
      `${STORE_MODULES.APP}/${APP_ACTION_TYPES.TRACK_GTM_EVENT}`,
      {
        type: 'search',
        data: { searchTerm: search, searchType },
      },
      { root: true },
    )
  },

  [TYPES.OPTIONS_REQUEST]: async (
    { state, commit, getters },
    { method = 'OPTIONS', data, url } = {},
  ) => {
    if (!url && !state[MUTATION_TYPES.OPTIONS.urlKey]) {
      return Promise.reject(new Error(`AIMEOS::Missing Options Url!`))
    }

    if (getters[`${MUTATION_TYPES.OPTIONS.BASE}_${REQUEST_STATE.STATE_PENDING}`]) {
      await state[MUTATION_TYPES.OPTIONS.promiseKey]
    }

    const params = {
      method,
      url: url || state[MUTATION_TYPES.OPTIONS.urlKey],
    }

    if (data) {
      params.data = data
    }

    const promise = axios(params)
      .then(response => {
        commit(MUTATION_TYPES.OPTIONS.BASE, {
          type: REQUEST_STATE.STATE_SUCCESS,
          data: response.data,
          status: response.status,
        })
        return response.data
      })
      .catch(error => {
        const status = get(error, 'response.status', 400)

        if (status === 404) {
          // commit([MUTATION_TYPES.BASKET.urlKey], null)
        }

        commit(MUTATION_TYPES.OPTIONS.BASE, {
          type: REQUEST_STATE.STATE_FAILURE,
          data: {},
          status: status,
          errorMessage: error.message,
        })

        // return Promise.reject(new Error(error.message))
        return {}
      })

    commit(MUTATION_TYPES.OPTIONS.BASE, { type: REQUEST_STATE.STATE_PENDING, promise })

    return promise
  },
  [TYPES.SET_BASKET_URL]: async ({ state, commit, dispatch }, url) => {
    if (get(state, MUTATION_TYPES.BASKET.urlKey) === url) {
      return Promise.resolve(get(state, MUTATION_TYPES.BASKET.dataKey))
    }

    commit(MUTATION_TYPES.BASKET.urlKey, url)
    return dispatch(TYPES.BASKET_REQUEST)
  },
  [TYPES.BASKET_REQUEST]: async (
    { state, commit, getters, rootGetters },
    { method = 'GET', data, url } = {},
  ) => {
    if (!rootGetters[`${STORE_MODULES.APP}/${APP_GETTER_TYPES.HAS_ROLE}`](DP_ROLE.SHOP_ORDER_R.p)) {
      return Promise.resolve({})
    }

    if (getters[`${MUTATION_TYPES.OPTIONS.BASE}_${REQUEST_STATE.STATE_PENDING}`]) {
      await state[MUTATION_TYPES.OPTIONS.promiseKey]
    }

    if (!url && !state[MUTATION_TYPES.BASKET.urlKey]) {
      return Promise.reject(new Error(`AIMEOS::Missing Basket Url!`))
    }

    if (getters[`${MUTATION_TYPES.BASKET.BASE}_${REQUEST_STATE.STATE_PENDING}`]) {
      // return state[MUTATION_TYPES.BASKET.promiseKey]
      await state[MUTATION_TYPES.BASKET.promiseKey]
    }

    // Todo: Automatically request again? Debounce this etc...
    // if (state[CONST.BASKET_STATE_FAILURE]) {
    // }

    const params = {
      method,
      url: url || state[MUTATION_TYPES.BASKET.urlKey],
    }

    if (data) {
      params.data = data
    }

    const promise = axios(params)
      .then(response => {
        const transformedData = generateOrderData({
          apiData: response.data,
        })
        // console.log(transformedData)

        commit(MUTATION_TYPES.BASKET.BASE, {
          type: REQUEST_STATE.STATE_SUCCESS,
          data: transformedData,
          status: response.status,
        })
        return transformedData
      })
      .catch(error => {
        const status = get(error, 'response.status', 400)

        if (status === 404) {
          // commit([MUTATION_TYPES.BASKET.urlKey], null)
        }

        commit(MUTATION_TYPES.BASKET.BASE, {
          type: REQUEST_STATE.STATE_FAILURE,
          data: {},
          status: status,
          errorMessage: error.message,
        })

        // Todo: See above.. request basket again etc...?
        // return Promise.reject(new Error(error.message))
        return {}
      })

    commit(MUTATION_TYPES.BASKET.BASE, { type: REQUEST_STATE.STATE_PENDING, promise })

    return promise
  },
  [TYPES.CLEAR_PRODUCTS]: async ({ commit, getters, state }, { url } = {}) => {
    if (getters[`${MUTATION_TYPES.PRODUCTS.BASE}_${REQUEST_STATE.STATE_PENDING}`]) {
      await state[MUTATION_TYPES.PRODUCTS.promiseKey]
    }

    if (url !== state[MUTATION_TYPES.PRODUCTS.urlKey]) {
      commit(MUTATION_TYPES.PRODUCTS.BASE, {
        type: REQUEST_STATE.STATE_INITIAL,
      })
    }
  },
  [TYPES.GET_PRODUCTS]: async ({ state, commit, getters }, { method = 'GET', data, url } = {}) => {
    if (url) {
      commit(MUTATION_TYPES.PRODUCTS.urlKey, url)
    }
    if (!state[MUTATION_TYPES.PRODUCTS.urlKey]) {
      return Promise.reject(new Error(`AIMEOS::Missing Products Url!`))
    }

    if (getters[`${MUTATION_TYPES.PRODUCTS.BASE}_${REQUEST_STATE.STATE_PENDING}`]) {
      // return state[MUTATION_TYPES.PRODUCTS.promiseKey]
      await state[MUTATION_TYPES.PRODUCTS.promiseKey]
    }

    const params = {
      method,
      url: state[MUTATION_TYPES.PRODUCTS.urlKey],
    }

    if (data) {
      params.data = data
    }

    const promise = axios(params)
      .then(response => {
        const transformedData = generateProductData({
          apiData: response.data,
        })
        // console.log(transformedData)

        commit(MUTATION_TYPES.PRODUCT.BASE, {
          type: REQUEST_STATE.STATE_SUCCESS,
          data: transformedData,
          status: response.status,
        })
        return transformedData

        // commit(MUTATION_TYPES.PRODUCTS.BASE, {
        //   type: REQUEST_STATE.STATE_SUCCESS,
        //   data: response.data,
        //   status: response.status,
        // })
        // return response.data
      })
      .catch(error => {
        const status = get(error, 'response.status', 400)

        if (status === 404) {
          // commit([MUTATION_TYPES.PRODUCTS.urlKey], null)
        }

        commit(MUTATION_TYPES.PRODUCTS.BASE, {
          type: REQUEST_STATE.STATE_FAILURE,
          data: {},
          status: status,
          errorMessage: error.message,
        })
        // return Promise.reject(new Error(error.message))
        return {}
      })

    commit(MUTATION_TYPES.PRODUCTS.BASE, { type: REQUEST_STATE.STATE_PENDING, promise })

    return promise
  },
  [TYPES.CLEAR_PRODUCT]: async ({ commit, getters, state }, { url } = {}) => {
    if (getters[`${MUTATION_TYPES.PRODUCT.BASE}_${REQUEST_STATE.STATE_PENDING}`]) {
      await state[MUTATION_TYPES.PRODUCT.promiseKey]
    }

    if (url !== state[MUTATION_TYPES.PRODUCT.urlKey]) {
      commit(MUTATION_TYPES.PRODUCT.BASE, {
        type: REQUEST_STATE.STATE_INITIAL,
      })
    }
  },
  [TYPES.GET_PRODUCT]: async (
    { state, commit, getters },
    {
      method = 'GET',
      data,
      url,
      id,
      include = 'media,price,text,attribute,product,product/property',
      currentSearch,
      scope,
      mergeColorAndFrameAttributes = false,
    } = {},
  ) => {
    if (isUndefined(id)) {
      return Promise.reject(new Error(`AIMEOS:GET_PRODUCT:Missing Product Id!`))
    }

    if (getters[`${MUTATION_TYPES.OPTIONS.BASE}_${REQUEST_STATE.STATE_PENDING}`]) {
      await state[MUTATION_TYPES.OPTIONS.promiseKey]
    }

    commit(MUTATION_TYPES.PRODUCT.urlKey, url || getters[AIMEOS_GETTER_TYPES.OPTIONS_PRODUCT_URL])

    if (!state[MUTATION_TYPES.PRODUCT.urlKey]) {
      return Promise.reject(new Error(`AIMEOS::Missing Product Url!`))
    }

    if (getters[`${MUTATION_TYPES.PRODUCT.BASE}_${REQUEST_STATE.STATE_PENDING}`]) {
      // return state[MUTATION_TYPES.PRODUCT.promiseKey]
      await state[MUTATION_TYPES.PRODUCT.promiseKey]
    }

    // ai[id]: 19364
    // ai[include]: media,price,text,attribute,product,product/property

    const params = {
      method,
      url: addGetParamToUrl(state[MUTATION_TYPES.PRODUCT.urlKey], { ai: { id, include, scope } }),
    }

    if (data) {
      params.data = data
    }

    const promise = axios(params).then(response => {
      const transformedData = generateProductData({
        productDetailData: true,
        apiData: response.data,
        currentSearch,
        mergeColorAndFrameAttributes,
        // rootGetters,
      })
      // console.log(transformedData)

      commit(MUTATION_TYPES.PRODUCT.BASE, {
        type: REQUEST_STATE.STATE_SUCCESS,
        data: transformedData,
        status: response.status,
      })
      return transformedData
    })
    // .catch(error => {
    //   const status = get(error, 'response.status', 400)

    //   if (status === 404) {
    //     // commit([MUTATION_TYPES.PRODUCT.urlKey], null)
    //   }

    //   commit(MUTATION_TYPES.PRODUCT.BASE, {
    //     type: REQUEST_STATE.STATE_FAILURE,
    //     data: {},
    //     status: status,
    //     errorMessage: error.message,
    //   })
    //   return Promise.reject(new Error(error.message))
    // })

    commit(MUTATION_TYPES.PRODUCT.BASE, {
      type: REQUEST_STATE.STATE_PENDING,
      promise,
      data: null,
    })

    return promise
  },
  [TYPES.PRODUCT_SEARCH]: async (
    { state, rootState, commit, getters, dispatch },
    { searchParams, productType = 'select' } = {},
  ) => {
    // console.log('searching…')
    // console.log(searchParams)
    const productResourceUrl = await getters[AIMEOS_GETTER_TYPES.GET_OPTIONS_PROMISE_URL](
      AIMEOS_META_CONSTANTS.PATHS.PRODUCT,
    ).catch(e => console.log(e))

    if (!productResourceUrl) {
      const errorMessage = 'Could not get product search URL'

      commit(MUTATION_TYPES.SEARCH.BASE, {
        type: REQUEST_STATE.STATE_FAILURE,
        data: {},
        status: 0,
        errorMessage,
      })

      return {}
    }

    // ToDo: page her raus.. hier nur offset nutzen.. die liste soll das berechnen
    const searchOffset = searchParams[FILTER_CONSTANTS.TYPE.SEARCH_PAGE]
      ? Math.max(0, searchParams[FILTER_CONSTANTS.TYPE.SEARCH_PAGE] - 1) *
        searchParams[FILTER_CONSTANTS.TYPE.SEARCH_LIMIT]
      : searchParams[FILTER_CONSTANTS.TYPE.SEARCH_OFFSET]

    const filters = {}

    // const scope = get(
    //   rootState[STORE_MODULES.APP],
    //   [APP_CONSTANTS.SCOPE],
    //   FILTER_CONSTANTS.IS_OUTLET.CURRENT,
    // )
    // const siteControlScopes = [
    //   FILTER_CONSTANTS.IS_OUTLET.CURRENT,
    //   FILTER_CONSTANTS.IS_OUTLET.OUTLET,
    // ]

    const scope = get(
      rootState[STORE_MODULES.APP],
      [APP_CONSTANTS.SCOPE],
      FILTER_CONSTANTS.SCOPE.ALL,
    )

    Object.entries({
      ...searchParams,
      // [BIKE_ATTRIBUTES.TYPE.SITE_CONTROL]: FILTER_CONSTANTS.SITE_CONTROL_SCOPES.includes(scope)
      //   ? rootGetters[`${STORE_MODULES.APP}/${APP_GETTER.SITE_ATTRIBUTES}`]
      //   : undefined,
    }).forEach(([key, value]) => {
      if (isUndefined(value) || isEmpty(value)) {
        return
      }

      switch (key) {
        // case BIKE_ATTRIBUTES.TYPE.SITE_CONTROL:
        // case BIKE_ATTRIBUTES.TYPE.ITEM_COLOR:
        case BIKE_ATTRIBUTES.TYPE.ITEM_BRAND:
        case BIKE_ATTRIBUTES.TYPE.PART_BRAND:
        case BIKE_ATTRIBUTES.TYPE.PRODUCT_SEGMENT:
        case BIKE_ATTRIBUTES.TYPE.ITEM_FILTER_COLOR:
        case BIKE_ATTRIBUTES.TYPE.ITEM_GENDER_FRAME:
        case BIKE_ATTRIBUTES.TYPE.EBIKE_ENGINE_MODEL:
        case BIKE_ATTRIBUTES.TYPE.EBIKE_SYSTEM_BRAND:
        case BIKE_ATTRIBUTES.TYPE.PRODUCT_MAIN_CATEGORY:
        case BIKE_ATTRIBUTES.TYPE.PRODUCT_BIDEX_COMMODITY_GROUP:
        case BIKE_ATTRIBUTES.TYPE.ITEM_WHEEL_SIZE_INCH:
        case BIKE_ATTRIBUTES.TYPE.ITEM_BATTERY_WATT_HOURS:
        case BIKE_ATTRIBUTES.TYPE.PRODUCT_GEAR_TYPE:
        case BIKE_ATTRIBUTES.TYPE.ITEM_COASTER_BRAKE:
        case BIKE_ATTRIBUTES.TYPE.PRODUCT_SEASON:
        case BIKE_ATTRIBUTES.TYPE.ITEM_SUPPLIER:
        case FILTER_CONSTANTS.TYPE.STOCK:
        case FILTER_CONSTANTS.TYPE.ITEM_BRAND_ARCHIV:
        case FILTER_CONSTANTS.TYPE.CATEGORY:
        case FILTER_CONSTANTS.TYPE.PIM_CATEGORY:
        case FILTER_CONSTANTS.TYPE.ZZCA_CLIENT:
        case FILTER_CONSTANTS.TYPE.HAS_OUTLET_SALES_PRICE:
          // set(filters, ['f_oneid', key], flatten(value))
          set(filters, ['f_attrid'], uniq([...get(filters, 'f_attrid', []), flatten(value)]))
          break
        // case FILTER_CONSTANTS.TYPE.CATEGORIES:
        //   set(filters, 'f_catid', flatten(value))
        //   break
        case FILTER_CONSTANTS.TYPE.SEARCH_TEXT: {
          const text = get(value, 0, '')
          if (text !== '') {
            set(filters, 'f_search', trim(text.replace(/^D(\d{9})$/, '$1'))) // Replace D<9 digits> with <9 digits>
          }
          break
        }
        case FILTER_CONSTANTS.TYPE.ARTICLE_TYPE:
        case FILTER_CONSTANTS.TYPE.PRODUCT_VARIANTS: {
          const flatValues = flatten(Object.values(value))
          set(filters, ['f_attrid'], uniq([...get(filters, 'f_attrid', []), flatValues]))
          break
        }
        case FILTER_CONSTANTS.TYPE.ITEM_FRAME_SIZE: {
          const flatValues = flatten(Object.values(value))
          if (!isEmpty(flatValues)) {
            // set(filters, ['f_oneid', key], flatValues)
            set(filters, ['f_attrid'], uniq([...get(filters, 'f_attrid', []), flatValues]))
          }
          break
        }
        case FILTER_CONSTANTS.TYPE.SEARCH_PRICE: {
          // console.log(FILTER_CONSTANTS.TYPE.SEARCH_PRICE, 'value', value)
          const minPrice = `${`${parseFloat(value[0]).toFixed(2)}`.padStart(12, '0')}` // 123456789.00
          const maxPrice = `${`${parseFloat(value[1]).toFixed(2)}`.padStart(12, '0')}`
          if (!has(filters, '&&')) {
            set(filters, '&&', [])
          }

          filters['&&'].push({
            '>=': {
              [`index.price:value("${value[2]}")`]: minPrice,
            },
          })

          filters['&&'].push({
            '<=': {
              [`index.price:value("${value[2]}")`]: maxPrice,
            },
          })
          // set(
          //   filters,
          //   ['&&'],
          //   [
          //     {
          //       '>=': {
          //         [`index.price:value("${value[2]}")`]: minPrice,
          //       },
          //     },
          //     {
          //       '<=': {
          //         [`index.price:value("${value[2]}")`]: maxPrice,
          //       },
          //     },
          //   ],
          // )
        }
      }
    })

    if (productType) {
      if (!has(filters, '&&')) {
        set(filters, '&&', [])
      }

      filters['&&'].push({ '==': { 'product.type': productType } })
    }

    if (!has(filters, '&&')) {
      set(filters, '&&', [])
    }

    // console.log({ filters })
    const filterParams = Object.entries(filters).reduce((acc, [key, values]) => {
      switch (key) {
        case 'f_oneid':
        case 'f_search':
        case 'f_catid':
          acc[key] = values
          break
        case 'f_attrid':
          // We do not use multi-dimensional f_attrid anymore.. replaced by the filters below
          // These are the same we use for the aggregate function
          // acc[key] = values
          acc['&&'] = [
            ...get(acc, '&&', []),
            ...values.reduce((acc, ids) => {
              if (ids.length === 1) {
                acc.push({
                  '==': {
                    'index.attribute.id': ids,
                  },
                })
                return acc
              }
              const orCase = {}
              orCase['||'] = ids.map(id => ({
                '==': {
                  'index.attribute.id': [id],
                },
              }))
              acc.push(orCase)
              return acc
            }, []),
          ]
          break
        case '&&':
          // console.log('filter &&', get(acc, '&&', []), values)
          acc['&&'] = [...get(acc, '&&', []), ...values]
          break
        default: {
          Object.entries(values).forEach(([key, ids]) => {
            if (!has(acc, key)) {
              acc[key] = []
            }
            acc[key] = [...acc[key], ...ids]
          })
          // acc['&&'].push(values)
        }
      }
      return acc
    }, {})
    // console.log({ filterParams })
    const urlParams = {
      'ai[filter]': filterParams,
      'ai[include]': searchParams[FILTER_CONSTANTS.TYPE.SEARCH_INCLUDED],
      'ai[page]': {
        // offset: searchOffset,
        limit: searchParams[FILTER_CONSTANTS.TYPE.SEARCH_LIMIT],
      },
      'ai[scope]': FILTER_CONSTANTS.IS_OUTLET[scope], // ToDo: Check with BE is IS_OUTLET is necessary
      'ai[dpsearch]': 'index.attribute.id', //'index.attribute.id,index.catalog.id',

      // 'ai[sort]': 'price',
    }
    if (!searchParams?.[FILTER_CONSTANTS.TYPE.SEARCH_TEXT]) {
      urlParams['ai[sort]'] = 'product.label'
    }
    // const params = {
    //   method: 'GET',
    //   url: `${productResourceUrl}&${stringify(urlParams)}`,
    // }
    // console.log(urlParams)

    // Check if the request is the same as the previous one (example: coming back from detail page)
    const productsRequestParams = JSON.stringify({ urlParams })
    const paramsOfLastRequest = get(
      rootState[STORE_MODULES.PRODUCTS][PRODUCT_CONSTANTS.PRODUCTS_REQUEST_PARAMS],
      'params',
    )
    const productsRequestParamsAreEqual = productsRequestParams === paramsOfLastRequest

    // If Search params are chagend reset search page to 1.
    if (!productsRequestParamsAreEqual && searchOffset !== 0) {
      commit(
        `${STORE_MODULES.SEARCH}/${SEARCH_MUTATION_TYPES.SET_SEARCH_PARAMS}`,
        {
          [FILTER_CONSTANTS.TYPE.SEARCH_OFFSET]: 0,
          [FILTER_CONSTANTS.TYPE.SEARCH_PAGE]: 1,
        },
        { root: true },
      )
      // Return previous search The new search will be triggered by search params watcher
      return state[MUTATION_TYPES.SEARCH.promiseKey]
    }

    const searchOffsetOfLastRequest = get(
      rootState[STORE_MODULES.PRODUCTS][PRODUCT_CONSTANTS.PRODUCTS_REQUEST_PARAMS],
      'searchOffset',
    )
    const seachOffsetIsEqual = searchOffsetOfLastRequest === searchOffset

    if (productsRequestParamsAreEqual && seachOffsetIsEqual) {
      // console.log('PRODUCT_SEARCH: request not changed')
      return Promise.resolve(getters[AIMEOS_GETTER_TYPES.PRODUCT_DATA])
    }

    const cancelSource = ProductSearchCancelToken.source()
    urlParams['ai[page]'].offset = searchOffset
    const params = {
      method: 'GET',
      url: `${productResourceUrl}&${stringify(urlParams)}`,
      cancelToken: cancelSource.token,
    }

    // console.log(
    //   `Product search is pending: ${
    //     getters[`${MUTATION_TYPES.SEARCH.BASE}_${REQUEST_STATE.STATE_PENDING}`]
    //   }`,
    // )

    if (getters[`${MUTATION_TYPES.SEARCH.BASE}_${REQUEST_STATE.STATE_PENDING}`]) {
      if (state[MUTATION_TYPES.SEARCH.cancelSource]) {
        // console.log('cancel previous request')
        state[MUTATION_TYPES.SEARCH.cancelSource].cancel('override by new request')
      }
      await state[MUTATION_TYPES.SEARCH.promiseKey]
    }

    commit(
      `${STORE_MODULES.PRODUCTS}/${PRODUCT_MUTATION_TYPES.SET_PRODUCTS_REQUEST_PARAMS}`,
      { params: productsRequestParams, searchOffset },
      { root: true },
    )

    // console.log('start product search request')
    const promise = axios(params)
      .then(response => {
        // console.log('search result')
        commit(
          `${STORE_MODULES.PRODUCTS}/${PRODUCT_MUTATION_TYPES.CLEAR_AVAILABILITIES_BY_TYPE}`,
          AVAILABILITY_STORE_TYPES.SEARCH,
          { root: true },
        )

        const transformedData = generateProductData({
          apiData: response.data,
        })
        // console.log(transformedData)

        commit(MUTATION_TYPES.SEARCH.BASE, {
          type: REQUEST_STATE.STATE_SUCCESS,
          data: transformedData,
          status: response.status,
        })
        // const attributes = get(transformedData, 'attributes')
        // if (attributes.length) {
        //   dispatch(
        //     `${STORE_MODULES.APP}/${APP_ACTIONS.SET_FILTER_DATA}`,
        //     { attributes, scope },
        //     { root: true },
        //   )
        // }

        return transformedData
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          // console.log('Request canceled', error.message)
          commit(MUTATION_TYPES.SEARCH.BASE, {
            type: REQUEST_STATE.STATE_INITIAL,
            data: {},
            status: null,
            errorMessage: error.message,
          })
          return
        }
        const status = get(error, 'response.status', 400)

        commit(MUTATION_TYPES.SEARCH.BASE, {
          type: REQUEST_STATE.STATE_FAILURE,
          data: {},
          status: status,
          errorMessage: error.message,
        })

        // return Promise.reject(new Error(error.message))
        return {}
      })
      .finally(() => {
        if (!isEmpty(filters.f_search)) {
          dispatch(TYPES.TRACK_PRODUCT_SEARCH, { searchParams, filters })
        }
      })

    commit(MUTATION_TYPES.SEARCH.BASE, {
      type: REQUEST_STATE.STATE_PENDING,
      promise,
      cancelSource,
    })

    return promise
  },
  [TYPES.GET_CLIENT]: async ({ state, commit, getters, rootGetters }) => {
    console.log('GET_CLIENT')
    if (!rootGetters[`${STORE_MODULES.APP}/${APP_GETTER.CLIENT_DATA_URL}`]) {
      return Promise.reject(new Error(`AIMEOS::Missing ClientData Url!`))
    }

    if (getters[`${MUTATION_TYPES.CLIENT.BASE}_${REQUEST_STATE.STATE_PENDING}`]) {
      await state[MUTATION_TYPES.CLIENT.promiseKey]
    }

    const params = {
      method: 'GET',
      url: rootGetters[`${STORE_MODULES.APP}/${APP_GETTER.CLIENT_DATA_URL}`],
    }

    const promise = axios(params)
      .then(response => {
        commit(MUTATION_TYPES.CLIENT.BASE, {
          type: REQUEST_STATE.STATE_SUCCESS,
          data: response.data,
          status: response.status,
        })
        return response.data
      })
      .catch(error => {
        const status = get(error, 'response.status', 400)

        if (status === 404) {
          // commit([MUTATION_TYPES.BASKET.urlKey], null)
        }

        commit(MUTATION_TYPES.CLIENT.BASE, {
          type: REQUEST_STATE.STATE_FAILURE,
          data: {},
          status: status,
          errorMessage: error.message,
        })

        // Todo: See above.. request basket again etc...?
        // return Promise.reject(new Error(error.message))
        return {}
      })

    commit(MUTATION_TYPES.CLIENT.BASE, { type: REQUEST_STATE.STATE_PENDING, promise })

    return promise
  },
  [TYPES.SET_FAVORITE_URL]: ({ state, commit, dispatch }, url) => {
    if (get(state, MUTATION_TYPES.FAVORITE.urlKey) === url) {
      return
    }
    commit(MUTATION_TYPES.FAVORITE.urlKey, url)
    return dispatch(TYPES.FAVORITE_REQUEST)
  },
  [TYPES.FAVORITE_REQUEST]: async (
    { state, commit, getters, dispatch, rootGetters },
    { method = 'GET', data, url, include = 'product', requestAfterParams } = {},
  ) => {
    if (
      !rootGetters[`${STORE_MODULES.APP}/${APP_GETTER_TYPES.HAS_ROLE}`](DP_ROLE.SHOP_FAVORITES_R.p)
    ) {
      return Promise.resolve({})
    }

    if (!url && !state[MUTATION_TYPES.FAVORITE.urlKey]) {
      return Promise.resolve({})
      // return Promise.reject(new Error(`AIMEOS::Missing FAVORITE Url!`))
    }

    if (
      getters[`${MUTATION_TYPES.FAVORITE.BASE}_${REQUEST_STATE.STATE_PENDING}`] &&
      !isUndefined(requestAfterParams)
    ) {
      await state[MUTATION_TYPES.FAVORITE.promiseKey]
    }

    const finalUrl = url || state[MUTATION_TYPES.FAVORITE.urlKey]
    const resultUrl = include
      ? `${finalUrl}${/\?/.test(finalUrl) ? '&' : '?'}ai%5Binclude%5D=${encodeURIComponent(
          include,
        )}`
      : finalUrl

    const params = {
      method,
      url: resultUrl,
    }

    if (data) {
      params.data = data
    }

    const promise = axios(params)
      .then(response => {
        if (!isUndefined(requestAfterParams)) {
          return dispatch(TYPES.FAVORITE_REQUEST, requestAfterParams)
        }
        commit(MUTATION_TYPES.FAVORITE.BASE, {
          type: REQUEST_STATE.STATE_SUCCESS,
          data: response.data,
          status: response.status,
        })
        dispatch(TYPES.FAVORITEPRODUCTS_REQUEST)
        dispatch(TYPES.AVAILABILITY_WATCH_REQUEST)
        return response.data
      })
      .catch(error => {
        const status = get(error, 'response.status', 400)

        if (requestAfterParams) {
          return dispatch(TYPES.FAVORITE_REQUEST, requestAfterParams)
        }

        commit(MUTATION_TYPES.FAVORITE.BASE, {
          type: REQUEST_STATE.STATE_FAILURE,
          data: {},
          status: status,
          errorMessage: error.message,
        })

        // return Promise.reject(new Error(error.message))
        return {}
      })

    commit(MUTATION_TYPES.FAVORITE.BASE, { type: REQUEST_STATE.STATE_PENDING, promise })

    return promise
  },
  [TYPES.FAVORITE_ADD_PRODUCT]: async (
    { dispatch, rootGetters },
    { productId, config = [] } = {},
  ) => {
    if (
      !rootGetters[`${STORE_MODULES.APP}/${APP_GETTER_TYPES.HAS_ROLE}`](DP_ROLE.SHOP_FAVORITES_W.p)
    ) {
      return Promise.resolve({})
    }
    const attributes = {
      'customer.lists.domain': 'product',
      'customer.lists.type': 'favorite',
      'customer.lists.refid': productId,
    }

    if (config.length) {
      attributes['customer.lists.config'] = config
    }

    return dispatch(TYPES.FAVORITE_REQUEST, {
      method: 'POST',
      data: {
        data: [
          {
            attributes,
          },
        ],
      },
    })
  },
  [TYPES.FAVORITE_REMOVE_PRODUCT]: async (
    { dispatch, getters, state, rootGetters },
    { /*productId,*/ config = [] } = {},
  ) => {
    if (
      !rootGetters[`${STORE_MODULES.APP}/${APP_GETTER_TYPES.HAS_ROLE}`](DP_ROLE.SHOP_FAVORITES_W.p)
    ) {
      return Promise.resolve({})
    }
    const isProductVariant = !!config.find(item => {
      return item.type === 'type' && item.value === 'default'
    })
    const code = config.find(item => item.type === 'code')?.value
    const productVariantCode = isProductVariant && code
    const url = state[MUTATION_TYPES.FAVORITE.urlKey]
    const relatedId = get(getters[AIMEOS_GETTER_TYPES.FAVORITE_SKU_TO_RELATEDID], code)

    const isOnReminderList =
      productVariantCode &&
      getters[AIMEOS_GETTER_TYPES.AVAILABILITYWATCH_IS_SKU_ON_LIST](productVariantCode)

    const promises = [
      dispatch(TYPES.FAVORITE_REQUEST, {
        method: 'DELETE',
        url: `${url}${/\?/.test(url) ? '&' : '?'}ai%5Brelatedid%5D=${relatedId}`,
        requestAfterParams: {},
      }),
    ]

    if (isOnReminderList) {
      promises.push(dispatch(TYPES.AVAILABILITY_WATCH_REMOVE_PRODUCT, productVariantCode))
    }

    const result = await Promise.allSettled(promises)
    return head(result)
  },
  [TYPES.FAVORITE_CHANGE_FAVORITE]: async (
    { dispatch, state, rootGetters },
    { relatedId, config = [] },
  ) => {
    if (
      !rootGetters[`${STORE_MODULES.APP}/${APP_GETTER_TYPES.HAS_ROLE}`](DP_ROLE.SHOP_FAVORITES_W.p)
    ) {
      return Promise.resolve({})
    }
    const url = state[MUTATION_TYPES.FAVORITE.urlKey]

    return dispatch(TYPES.FAVORITE_REQUEST, {
      method: 'PATCH',
      url: `${url}${/\?/.test(url) ? '&' : '?'}ai%5Brelatedid%5D=${relatedId}`,
      requestAfterParams: {},
      data: {
        data: {
          attributes: {
            'customer.lists.config': config,
          },
        },
      },
    })
  },
  [TYPES.FAVORITEPRODUCTS_REQUEST]: async ({ state, commit, getters }) => {
    commit(
      MUTATION_TYPES.FAVORITEPRODUCTS.urlKey,
      getters[AIMEOS_GETTER_TYPES.FAVORITE_PRODUCT_URL],
    )

    if (!state[MUTATION_TYPES.FAVORITEPRODUCTS.urlKey]) {
      return Promise.resolve({})
      // return Promise.reject(new Error(`AIMEOS::No Valid Favorite Products Url!`))
    }

    if (getters[`${MUTATION_TYPES.FAVORITEPRODUCTS.BASE}_${REQUEST_STATE.STATE_PENDING}`]) {
      // return state[MUTATION_TYPES.FAVORITEPRODUCTS.promiseKey]
      await state[MUTATION_TYPES.FAVORITEPRODUCTS.promiseKey]
    }

    const params =
      getters[AIMEOS_GETTER_TYPES.FAVORITE_PRODUCT_SKUS].length > 20
        ? {
            method: 'POST',
            url: state[MUTATION_TYPES.FAVORITEPRODUCTS.urlKey],
            data: {
              data: {
                sku: getters[AIMEOS_GETTER_TYPES.FAVORITE_PRODUCT_AND_PARENTS_SKUS].join(','),
              },
            },
          }
        : {
            method: 'GET',
            url: `${state[MUTATION_TYPES.FAVORITEPRODUCTS.urlKey]}${
              /\?/.test(state[MUTATION_TYPES.FAVORITEPRODUCTS.urlKey]) ? '&' : '?'
            }ai%5Bsku%5D=${getters[AIMEOS_GETTER_TYPES.FAVORITE_PRODUCT_AND_PARENTS_SKUS].join(
              ',',
            )}`,
          }

    const promise = axios(params)
      .then(response => {
        // console.log('FAVORITEPRODUCTS_REQUEST done')
        const transformedData = generateProductData({
          apiData: response.data,
          variantDetailData: true,
        })
        // console.log(transformedData)

        commit(MUTATION_TYPES.FAVORITEPRODUCTS.BASE, {
          type: REQUEST_STATE.STATE_SUCCESS,
          data: transformedData,
          status: response.status,
        })
        return transformedData
      })
      .catch(error => {
        const status = get(error, 'response.status', 400)

        if (status === 404) {
          // commit([MUTATION_TYPES.FAVORITEPRODUCTS.urlKey], null)
        }

        commit(MUTATION_TYPES.FAVORITEPRODUCTS.BASE, {
          type: REQUEST_STATE.STATE_FAILURE,
          data: {},
          status: status,
          errorMessage: error.message,
        })
        // return Promise.reject(new Error(error.message))
        return {}
      })

    commit(MUTATION_TYPES.FAVORITEPRODUCTS.BASE, {
      type: REQUEST_STATE.STATE_PENDING,
      promise,
    })

    return promise
  },
  [TYPES.SKU_REQUEST]: async ({ state, getters }, skus) => {
    if (getters[`${MUTATION_TYPES.OPTIONS.BASE}_${REQUEST_STATE.STATE_PENDING}`]) {
      await state[MUTATION_TYPES.OPTIONS.promiseKey]
    }

    const url = `${getters[AIMEOS_GETTER_TYPES.OPTIONS_SKUS_URL]}${
      /\?/.test(getters[AIMEOS_GETTER_TYPES.OPTIONS_SKUS_URL]) ? '&' : '?'
    }ai%5Binclude%5D=media%2Cprice%2Cproduct%2Fproperty%2Cattribute%2Ctext&ai%5Bscope%5D=dealerbook`

    const params =
      skus.length > 20
        ? {
            method: 'POST',
            url,
            data: {
              data: {
                sku: skus,
              },
            },
          }
        : {
            method: 'GET',
            url: `${url}&ai%5Bsku%5D=${skus}`,
          }

    const promise = axios(params)
      .then(response => {
        const transformedData = generateProductData({
          apiData: response.data,
          productDetailData: true,
          mergeColorAndFrameAttributes: true,
        })

        return transformedData
      })
      .catch(error => {
        const status = get(error, 'response.status', 400)

        if (status === 404) {
          // commit([MUTATION_TYPES.FAVORITEPRODUCTS.urlKey], null)
        }

        // return Promise.reject(new Error(error.message))
        return {}
      })

    return promise
  },
  [TYPES.GET_PRODUCT_SPAREPARTS]: async (
    { state, commit, getters },
    {
      method = 'GET',
      data,
      url,
      serialNumber,
      bikeInfoSN,
      sku,
      include = 'media,price,text,attribute,product/property',
    } = {},
  ) => {
    if (isUndefined(serialNumber) && isUndefined(sku) && isUndefined(bikeInfoSN)) {
      return Promise.reject(new Error(`AIMEOS:GET_PRODUCT_SPAREPARTS:Missing serialNumber or sku!`))
    }

    if (getters[`${MUTATION_TYPES.OPTIONS.BASE}_${REQUEST_STATE.STATE_PENDING}`]) {
      await state[MUTATION_TYPES.OPTIONS.promiseKey]
    }

    commit(
      MUTATION_TYPES.PRODUCTSPAREPARTS.urlKey,
      url || getters[AIMEOS_GETTER_TYPES.OPTIONS_SPAREPARTS_URL],
    )

    if (!state[MUTATION_TYPES.PRODUCTSPAREPARTS.urlKey]) {
      return Promise.reject(new Error(`AIMEOS::Missing Product Url!`))
    }

    if (getters[`${MUTATION_TYPES.PRODUCTSPAREPARTS.BASE}_${REQUEST_STATE.STATE_PENDING}`]) {
      await state[MUTATION_TYPES.PRODUCTSPAREPARTS.promiseKey]
    }

    const ai = { include, scope: 'archive' }

    if (!isUndefined(serialNumber)) {
      ai.serialnumber = serialNumber
    } else if (!isUndefined(sku)) {
      ai.sku = sku
    } else if (!isUndefined(bikeInfoSN)) {
      ai.bikeInfoSN = bikeInfoSN
    }

    const params = {
      method,
      url: addGetParamToUrl(state[MUTATION_TYPES.PRODUCTSPAREPARTS.urlKey], {
        ai,
      }),
    }

    if (data) {
      params.data = data
    }

    const promise = axios(params)
      .then(response => {
        const transformedData = generateProductData({
          productDetailData: true,
          apiData: response.data,
        })

        commit(MUTATION_TYPES.PRODUCTSPAREPARTS.BASE, {
          type: REQUEST_STATE.STATE_SUCCESS,
          data: transformedData,
          status: response.status,
        })
        return transformedData
      })
      .catch(error => {
        const status = get(error, 'response.status', 400)
        const errorMessage = get(error, ['response', 'data', 'errors', 0, 'title']) || error.message

        // if (status === 404) {
        // commit([MUTATION_TYPES.PRODUCTS.urlKey], null)
        // }

        commit(MUTATION_TYPES.PRODUCTSPAREPARTS.BASE, {
          type: REQUEST_STATE.STATE_FAILURE,
          data: {},
          status: status,
          errorMessage: errorMessage,
        })
        return []
      })

    commit(MUTATION_TYPES.PRODUCTSPAREPARTS.BASE, {
      type: REQUEST_STATE.STATE_PENDING,
      promise,
      data: null,
    })

    return promise
  },
  [TYPES.GET_PRODUCT_ATTRIBUTES]: async (
    { state, commit, getters },
    {
      all = 0,
      allCount = 0,
      scope,
      filterAttributes = [],
      currentUser,
      productType = AIMEOS.PRODUCTS.TYPE.SELECT,
    } = {},
  ) => {
    console.log('GET_PRODUCT_ATTRIBUTES')
    if (getters[`${MUTATION_TYPES.OPTIONS.BASE}_${REQUEST_STATE.STATE_PENDING}`]) {
      await state[MUTATION_TYPES.OPTIONS.promiseKey]
    }

    commit(
      MUTATION_TYPES.PRODUCTATTRIBUTES.urlKey,
      getters[AIMEOS_GETTER_TYPES.OPTIONS_PRODUCT_URL],
    )

    if (!state[MUTATION_TYPES.PRODUCTATTRIBUTES.urlKey]) {
      return Promise.reject(new Error(`AIMEOS::Missing Product Url!`))
    }

    if (getters[`${MUTATION_TYPES.PRODUCTATTRIBUTES.BASE}_${REQUEST_STATE.STATE_PENDING}`]) {
      await state[MUTATION_TYPES.PRODUCTATTRIBUTES.promiseKey]
    }

    const ai = {
      filter: {},
      page: {
        limit: 20000,
      },
      dpaggregate: 'index.attribute.id',
      scope,
      currentUser,
      attribute: {
        limit: 20000,
        all,
        allCount,
      },
    }

    ai.filter['&&'] = filterAttributes.reduce(
      (acc, [, ids]) => {
        if (ids.length === 1) {
          acc.push({
            '==': {
              'index.attribute.id': ids,
            },
          })
          return acc
        }
        const orCase = {}
        orCase['||'] = ids.map(id => ({
          '==': {
            'index.attribute.id': [id],
          },
        }))
        acc.push(orCase)
        return acc
      },
      [
        {
          '==': {
            'product.type': productType,
          },
        },
      ],
    )

    const params = {
      method: 'GET',
      url: addGetParamToUrl(state[MUTATION_TYPES.PRODUCTATTRIBUTES.urlKey], {
        ai,
      }),
    }

    const promise = axios(params)
      .then(response => {
        const data = get(response, 'data', {})

        commit(MUTATION_TYPES.PRODUCTATTRIBUTES.BASE, {
          type: REQUEST_STATE.STATE_SUCCESS,
          data,
          status: get(response, 'status'),
        })
        return data
      })
      .catch(error => {
        const status = get(error, 'response.status', 400)

        if (status === 404) {
          // commit([MUTATION_TYPES.PRODUCTS.urlKey], null)
        }

        commit(MUTATION_TYPES.PRODUCTATTRIBUTES.BASE, {
          type: REQUEST_STATE.STATE_FAILURE,
          data: {},
          status: status,
          errorMessage: error.message,
        })
        // return Promise.reject(new Error(error.message))
        return {}
      })

    commit(MUTATION_TYPES.PRODUCTATTRIBUTES.BASE, {
      type: REQUEST_STATE.STATE_PENDING,
      promise,
      data: null,
    })

    return promise
  },
  // [TYPES.GET_PRODUCT_ATTRIBUTES]: async (
  //   { state, commit, getters },
  //   { all = 1, filterAttributes = [] } = {},
  // ) => {
  //   console.log('GET_PRODUCT_ATTRIBUTES')
  //   if (getters[`${MUTATION_TYPES.OPTIONS.BASE}_${REQUEST_STATE.STATE_PENDING}`]) {
  //     await state[MUTATION_TYPES.OPTIONS.promiseKey]
  //   }

  //   commit(
  //     MUTATION_TYPES.PRODUCTATTRIBUTES.urlKey,
  //     getters[AIMEOS_GETTER_TYPES.OPTIONS_PRODUCT_URL],
  //   )

  //   if (!state[MUTATION_TYPES.PRODUCTATTRIBUTES.urlKey]) {
  //     return Promise.reject(new Error(`AIMEOS::Missing Product Url!`))
  //   }

  //   if (getters[`${MUTATION_TYPES.PRODUCTATTRIBUTES.BASE}_${REQUEST_STATE.STATE_PENDING}`]) {
  //     await state[MUTATION_TYPES.PRODUCTATTRIBUTES.promiseKey]
  //   }

  //   const ai = {
  //     page: {
  //       limit: 20000,
  //     },
  //     dpaggregate: 'index.attribute.id',
  //     attribute: {
  //       limit: 20000,
  //       all,
  //     },
  //   }

  //   if (filterAttributes.length) {
  //     // ai.filter = ['&&']
  //     ai.filter = {}
  //     ai.filter['&&'] = filterAttributes.reduce((acc, [, ids]) => {
  //       if (ids.length === 1) {
  //         acc.push({
  //           '==': {
  //             'index.attribute.id': ids,
  //           },
  //         })
  //         return acc
  //       }
  //       const orCase = {}
  //       orCase['||'] = ids.map(id => ({
  //         '==': {
  //           'index.attribute.id': [id],
  //         },
  //       }))
  //       acc.push(orCase)
  //       return acc
  //     }, [])
  //   }

  //   const priceRequestAi = {
  //     page: {
  //       limit: 1,
  //     },
  //     filter: ai.filter,
  //     include: 'price',
  //     sort: '-price',
  //     fields: {
  //       product: 'product.id,product.label',
  //       'customer/group': '',
  //       price: 'price.value,price.costs,price.currencyid,price.type',
  //     },
  //   }
  //   const priceRequestParams = {
  //     method: 'GET',
  //     url: addGetParamToUrl(state[MUTATION_TYPES.PRODUCTATTRIBUTES.urlKey], {
  //       ai: priceRequestAi,
  //     }),
  //   }

  //   const params = {
  //     method: 'GET',
  //     url: addGetParamToUrl(state[MUTATION_TYPES.PRODUCTATTRIBUTES.urlKey], {
  //       ai,
  //     }),
  //   }

  //   const promise = Promise.all([
  //     axios(params)
  //       .then(response => {
  //         const data = get(response, ['data', 'data'], [])

  //         commit(MUTATION_TYPES.PRODUCTATTRIBUTES.BASE, {
  //           type: REQUEST_STATE.STATE_SUCCESS,
  //           data,
  //           status: get(response, 'status'),
  //         })
  //         return data
  //       })
  //       .catch(error => {
  //         const status = get(error, 'response.status', 400)

  //         if (status === 404) {
  //           // commit([MUTATION_TYPES.PRODUCTS.urlKey], null)
  //         }

  //         commit(MUTATION_TYPES.PRODUCTATTRIBUTES.BASE, {
  //           type: REQUEST_STATE.STATE_FAILURE,
  //           data: {},
  //           status: status,
  //           errorMessage: error.message,
  //         })
  //         return Promise.reject(new Error(error.message))
  //       }),
  //     axios(priceRequestParams)
  //       .then(response => {
  //         return get(
  //           getPriceInfo({
  //             apiData: get(response, 'data', {}),
  //           }),
  //           ['data', 0],
  //           {},
  //         )
  //       })
  //       .catch(error => {
  //         return Promise.reject(new Error(error.message))
  //       }),
  //   ])

  //   commit(MUTATION_TYPES.PRODUCTATTRIBUTES.BASE, {
  //     type: REQUEST_STATE.STATE_PENDING,
  //     promise,
  //     data: null,
  //   })

  //   return promise
  // },
  [TYPES.GET_BLOCKINGREASONS]: async (
    { state, commit, getters, rootGetters },
    { method = 'GET', url } = {},
  ) => {
    if (
      !rootGetters[`${STORE_MODULES.APP}/${APP_GETTER_TYPES.HAS_ROLE}`](
        DP_ROLE.ACCOUNT_BLOCKINGREASONS_R.p,
      )
    ) {
      return Promise.resolve({})
    }

    const params = {
      method,
      url: url ? url : rootGetters[`${STORE_MODULES.APP}/${APP_GETTER_TYPES.BLOCKINGREASON_URL}`],
    }

    if (getters[`${MUTATION_TYPES.BLOCKINGREASONS.BASE}_${REQUEST_STATE.STATE_PENDING}`]) {
      await state[MUTATION_TYPES.BLOCKINGREASONS.promiseKey]
    }

    const promise = axios(params)
      .then(response => {
        commit(MUTATION_TYPES.BLOCKINGREASONS.BASE, {
          type: REQUEST_STATE.STATE_SUCCESS,
          data: response.data,
          status: response.status,
        })

        return response.data
      })
      .catch(error => {
        const status = get(error, 'response.status', 400)

        commit(MUTATION_TYPES.BLOCKINGREASONS.BASE, {
          type: REQUEST_STATE.STATE_FAILURE,
          data: {},
          status: status,
          errorMessage: error.message,
        })
        // return Promise.reject(new Error(error.message))
        return {}
      })

    commit(MUTATION_TYPES.BLOCKINGREASONS.BASE, { type: REQUEST_STATE.STATE_PENDING, promise })

    return promise
  },
  [TYPES.GET_ADDRESS_FOR_SAP_ID]: async ({ getters }, id = undefined) => {
    const sapId = id?.replace(/\b0+/g, '')
    if (sapId) {
      const customerAddresses = getters[AIMEOS_GETTER_TYPES.CUSTOMER_DELIVERY_ADDRESSES]
      const matchedAddress = customerAddresses.find(
        address => address.attributes[ADDRESS_CONSTANTS.ATTRIBUTE.SAP_ADDRESS_ID] == sapId,
      )

      if (matchedAddress) {
        return {
          id: matchedAddress.attributes[ADDRESS_CONSTANTS.ATTRIBUTE.ID],
          name: matchedAddress.attributes[ADDRESS_CONSTANTS.ATTRIBUTE.COMPANY],
          zip: matchedAddress.attributes[ADDRESS_CONSTANTS.ATTRIBUTE.POSTAL],
          city: matchedAddress.attributes[ADDRESS_CONSTANTS.ATTRIBUTE.CITY],
          street: matchedAddress.attributes[ADDRESS_CONSTANTS.ATTRIBUTE.ADDRESS1],
        }
      } else {
        return {}
      }
    } else {
      return {}
    }
  },
  [TYPES.HAS_BLOCKINGREASON_KEY]: ({ state }, blockingKey = '') => {
    const customerData =
      get(state, MUTATION_TYPES.BLOCKINGREASONS.dataKey)?.blockingreasonList ?? []

    return customerData.some(data => data.blockingReasons.some(reason => reason === blockingKey))
  },
})
